import React, { useState, useEffect, Suspense } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from "framer-motion"

import HomePage from './pages/homepage/Home'
import aboutPage from './pages/aboutPage/About'
import ContactPage from './pages/contactPage/Contact'
import Faqs from './pages/faqsPage/Faqs'
import Admin from './pages/admin/Admin'
import SpecificContact from './pages/specificContact/SpecificContact'
import Error404Page from './pages/error404Page/Error404'

function Router(props) {

    const location = useLocation();
    // console.log(location)

    const [goHome, setGoHome] = useState(false)

    useEffect(() => {
      if(location.pathname === "/"){
        setGoHome(true)
      }
    }, [])

    const pageVariants = {
      initial: {
        opacity: 0
      },
      in: {
        opacity: 1
      },
      out: {
        opacity: 0
      }
    };

    const pageTransition = {
      type: 'tween',
      ease: 'linear',
      duration: 0.3
    };

    const SuspenseLoading = () => {
        const [isVisible, setIsVisible] = useState(false);
        useEffect(() => {
          let timeout = setTimeout(() => setIsVisible(true), 300);
          return () => {
            clearTimeout(timeout);
          };
        }, []);

        return (
          <>
            <AnimatePresence>
              {isVisible && (
                <motion.div
                  key="loading"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.4 }}>
                  <div className="text-center text-6xl text-red-900"> Chargement de l'application... </div>
                </motion.div>
              )}
            </AnimatePresence>
          </>
        );
      };

    return (
        <AnimatePresence>
            <Suspense fallback={ <SuspenseLoading /> }>
                <Switch location={location} key={location.pathname}>
                  
                  <motion.div
                      initial="initial"
                      animate="in"
                      exit="out"
                      variants={ pageVariants }
                      transition={ pageTransition }
                  >
                      <Switch>
                          <Route exact path="/" component={HomePage} />
                          <Route  path="/about" component={aboutPage} />
                          <Route exact  path="/contact" component={ContactPage} />
                          <Route  path="/faqs" component={Faqs} />
                          <Route exact  path="/admin" component={Admin} />
                          <Route  path="/admin/contacts/:contactId" component={SpecificContact} />
                          <Route  component={Error404Page} />
                      </Switch>
                  </motion.div>
                </Switch>
                { goHome && <Redirect to="/" /> }
            </Suspense>
        </AnimatePresence>
    );
}

export default Router;